import React, { useState } from 'react'
import Slider from 'react-slick'
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";

const CustomPrevArrow = (props) => {
    const { onClick, currentSlide } = props
    const isFirstSlide = currentSlide === 0

    return (
        <button
            className={`absolute -bottom-3 left-[calc(50%-120px)] z-10 ${isFirstSlide ? 'text-gray-300' : 'text-black'}`}
            onClick={onClick}
            aria-label="Previous slide"
        >
            <IoMdArrowBack size={34} />            
        </button>
    )
}

const CustomNextArrow = (props) => {
    const { onClick, currentSlide, slideCount } = props
    const isLastSlide = currentSlide === slideCount - 1

    return (
        <button
            className={`absolute -bottom-3 right-[calc(50%-120px)] z-10 ${isLastSlide ? 'text-gray-300' : 'text-black'}`}
            onClick={onClick}
            aria-label="Next slide"
        >
            <IoMdArrowForward size={34} />
        </button>
    )
}

const Join = () => {
    const [activeTab, setActiveTab] = useState('Taste');

    const tabs = ['Taste', 'Value', 'vs. Powders', 'Benefits', 'Ingredients', 'Convenience'];

    const videos = [
        {
            url: 'https://player.vimeo.com/video/1026964420?h=3015b74557&loop=1'
        },
        {
            url: 'https://player.vimeo.com/video/1026964420?h=3015b74557&loop=1'
        },
        {
            url: 'https://player.vimeo.com/video/1026964420?h=3015b74557&loop=1'
        },
        {
            url: 'https://player.vimeo.com/video/1026964420?h=3015b74557&loop=1'
        },
        {
            url: 'https://player.vimeo.com/video/1026964420?h=3015b74557&loop=1'
        }
    ];

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: false,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
        dotsClass: "slick-dots !static flex justify-center items-center mt-4",
        className: "video-carousel"
    };

    const testimonialsByTab = {
        'Taste': [
            {
                stars: 5,
                text: "These gummies are shockingly delicious, like strawberries! I hate subscriptions because I feel like they are a trap so I canceled it before the gummies even arrived. We quickly decided to resubscribe because we love Grüns so much! A bonus is my kids love them too!",
                author: "Kate S."
            },
            {
                stars: 5,
                text: "10/10 would recommend. The convenience and taste are huge! Like mixed berries! Plus not having to clean a shaker bottle or extra dishes for greens stuff in powder form, is absolutely excellent!",
                author: "Dustin O."
            },
            {
                stars: 5,
                text: "A delicious adventure for your taste buds. These gummy bears are more than just a treat; they're a flavorful escape. With a burst of mouthwatering flavors, every bite is an invitation to a tasteful journey. Grüns makes healthy eating an indulgent experience.",
                author: "Kevin S."
            }
        ],
        'Value': [
            {
                stars: 5,
                text: "These gummies are amazing! Grüns has replaced multiple vitamins and supplements as they are all included in just one yummy little Grüns pack! (For WAY less than I was paying before). Best decision I ever made switching!! If you're on the fence, JUMP! You will not regret your decision!",
                author: "Rebecca D."
            },
            {
                stars: 5,
                text: "The benefits of eating these gummies daily is stacked. I used to pay so much for multiple supplements to get all of the same benefits that Grüns gives me in a simple snack pack.",
                author: "Jeremy H."
            },
            {
                stars: 5,
                text: "I was super skeptical. These gummies actually do taste really yummy and they're easy to throw in a packet and take with me so I can enjoy them anytime. I also stopped buying separate probiotic gummies, b12 gummies, and multivitamin gummies. I just take these now and it's easier for me to manage.",
                author: "Jamie W."
            }
        ],
        'vs. Powders': [
            {
                stars: 5,
                text: 'WOW! I\'ve tried a ton of green "things" over the years and I have to say, Grüns FOR THE WIN! I was taking AG1 but even with their monthly subscription discount it was still $94 a month and the drink was definitely gritty/chalky. Grüns literally tastes like fruit snacks I ate as a kid. And there isn\'t a bad aftertaste either! On top of that, they are super convenient, half the price of what I was paying with AG1, and offer the same benefits and then some! P.S. I never do reviews, but these are amazing!',
                author: "Anonymous"
            },
            {
                stars: 5,
                text: "I've tried a few green powders over the years. The issue has never been nutritive content. It's always been an issue of consistency like many things. Grüns has been the one thing I've been able to stick to because they are so easy to consume and taste wonderful (just like gummy bears).",
                author: "Samuel L."
            },
            {
                stars: 5,
                text: "Grüns is exactly what I needed. I've been choking on Athletic Greens for the last few years and am glad those days are over. I look forward to taking Grüns every day not only because they taste great but also because I know they're good for me.",
                author: "Jaxon S."
            }
        ],
        'Benefits': [
            {
                stars: 5,
                text: "My bowel movements are normal for the 1st time in 15 years!",
                author: "Wendy B."
            },
            {
                stars: 5,
                text: "Grüns really does taste great! More importantly, I feel great. The prebiotics do their job, but not aggressively, and I feel like my overall digestion has improved. This is huge for someone who suffers from chronic IBS! I feel like I'm already seeing improvements in my skin too. They are definitely part of my daily routine.",
                author: "Susan U."
            },
            {
                stars: 5,
                text: "If you are serious about changing your life, start here. The product is AMAZING! It provides clean feeling energy and mental focus in a good tasting gummy bear that satisfies a sweet tooth craving without the sugar crash.",
                author: "Jeremy C."
            }
        ],
        'Ingredients': [
            {
                stars: 5,
                text: "Pharmacist approved! Most other gummies on the market have only a few vitamins, but there are no other products like this with full spectrum vitamins in gummy form! I can't stop raving about Grüns to my friends. Definitely give them a try!",
                author: "Mercedes F."
            },
            {
                stars: 5,
                text: "1000/10. Truly exceeded my expectations! Love the taste, love how they make me feel, and so impressed by the ingredients list! Definitely will be taking these on vacation with me (bye bye green powder)!",
                author: "Gizelle C."
            },
            {
                stars: 5,
                text: "Grüns are the tastiest nutritional gummies I've ever had. They're more convenient, less messy, and more flavorful than green powders. They are easy to have on the go, so it's easy to build the daily habit of taking them. I've felt great since I started taking Grüns! So much nutrition packed into an easy habit. Do yourself a favor and get a subscription. You won't regret it!",
                author: "Matthew G."
            }
        ],
        'Convenience': [
            {
                stars: 5,
                text: "Portable! Love the flavor and it's so easy to grab and eat on my way to the billion things I have to do as a mom. Easy way to get my nutrients in!",
                author: "Kelli L."
            },
            {
                stars: 5,
                text: "I've been using Gruns Daily Gummies for a few weeks, and I'm hooked! The convenience of getting 60 nutrient-dense ingredients in a tasty gummy is unbeatable. They make meeting my daily nutrient needs a breeze, and the blend also supports gut health. I've noticed increased energy levels and an overall sense of vitality. It's perfect for on-the-go nutrition. Gruns has genuinely made a comprehensive daily nutrition solution enjoyable and accessible. Highly recommend!",
                author: "Crystal H."
            },
            {
                stars: 5,
                text: "It's wild I WANT to take Grüns and don't forget. I love that there are 8 gummies in each pack because taking just 2 gummies before Grüns was never satisfying. And that's before you get to all the health benefits.",
                author: "Brittany A."
            }
        ]
    };

    return (
        <div className="bg-[#dfefe7] py-8 md:py-16">
            <div className="max-w-[90%] md:max-w-[85%] mx-auto">
                <div className="text-center">
                    <div className="space-y-4 -mb-4">
                        <div className="flex items-center justify-center gap-2">
                            <span className="text-[#008037] text-xl md:text-2xl">★★★★★</span>
                            <span className="text-sm md:text-base">4.9 stars</span>
                        </div>
                        <h2 className="text-[#008037] text-[23px] md:text-[36px] font-semibold leading-[1.4] md:leading-normal">
                            Join 250,000+ Others Filling Their Nutrition Gaps
                        </h2>
                    </div>

                    <div className="grid grid-cols-2 md:flex md:flex-wrap justify-center gap-3 mt-8 md:mt-10">
                        {tabs.map((tab) => (
                            <button
                                key={tab}
                                onClick={() => setActiveTab(tab)}
                                className={`w-full md:w-[180px] px-3 md:px-4 py-2 md:py-2.5 rounded-[20px] text-[15px] md:text-lg font-medium transition-colors duration-200 border-2 border-black ${activeTab === tab
                                    ? 'bg-[#008037] text-white'
                                    : 'bg-transparent text-black hover:bg-[#e8f5ef] hover:border-[#008037]'
                                    }`}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>

                    <div className="grid md:grid-cols-3 gap-0 md:gap-6 mt-4 md:mt-8">
                        {testimonialsByTab[activeTab]?.map((testimonial, index) => (
                            <div key={index} className="text-center p-4 md:p-6 text-[14px] md:text-[15px]">
                                <div className="text-[#008037] text-xl md:text-2xl mb-3 md:mb-4">
                                    {'★'.repeat(testimonial.stars)}
                                </div>
                                <p className="text-black mb-3 md:mb-4 leading-relaxed">
                                    {testimonial.text}
                                </p>
                                <p className="font-medium text-[11px] md:text-xs text-black">
                                    {testimonial.author}
                                </p>
                            </div>
                        ))}
                    </div>

                    {/* Video cards row */}
                    <div className="block md:hidden mt-8 relative">
                        <div className="pb-16">
                            <Slider {...sliderSettings}>
                                {videos.map((video, index) => (
                                    <div key={index}>
                                        <div className="relative w-full aspect-[9/16] rounded-xl overflow-hidden">
                                            <div className="w-full h-full rounded-xl overflow-hidden">
                                                <iframe
                                                    src={video.url}
                                                    style={{
                                                        position: 'absolute',
                                                        top: 0,
                                                        left: 0,
                                                        width: '100%',
                                                        height: '100%',
                                                        borderRadius: '12px'
                                                    }}
                                                    frameBorder="0"
                                                    allow="fullscreen; picture-in-picture"
                                                    allowFullScreen
                                                ></iframe>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                    <div className="hidden md:grid md:grid-cols-5 gap-3 justify-items-center mt-8">
                        {videos.map((video, index) => (
                            <div key={index} className="relative w-full md:w-[210px] aspect-[9/16] rounded-xl overflow-hidden">
                                <div className="w-full h-full rounded-xl overflow-hidden">
                                    <iframe
                                        src={video.url}
                                        style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                            borderRadius: '12px'
                                        }}
                                        frameBorder="0"
                                        allow="fullscreen; picture-in-picture"
                                        allowFullScreen
                                    ></iframe>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Join
